import { render, staticRenderFns } from "./QsRemoteAccess.vue?vue&type=template&id=3681f2bd&scoped=true&"
import script from "./QsRemoteAccess.vue?vue&type=script&lang=js&"
export * from "./QsRemoteAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3681f2bd",
  null
  
)

export default component.exports